(() => {
  if (!customElements.get('bba-catalog-more')) {
    customElements.define('bba-catalog-more', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-bba-load-more]');
          if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (!this.loading) this.load(link);
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
      async load(link) {
        this.loading = true;
        this.controller = new AbortController();
        const grid = this.closest('#ProductGridContainer').querySelector('#product-grid');
        const status = this.querySelector('[role="status"]');
        this.setAttribute('aria-busy', 'true');
        link.setAttribute('aria-disabled', 'true');
        link.textContent = this.dataset.loading;
        try {
          const nextUrl = new URL(link.href, location.href);
          for (const [key, value] of new URLSearchParams(location.search)) {
            if (key !== 'page' && key !== 'section_id' && !nextUrl.searchParams.has(key)) nextUrl.searchParams.append(key, value);
          }
          nextUrl.searchParams.set('section_id', grid.dataset.id);
          const response = await fetch(nextUrl, {signal: this.controller.signal, credentials: 'same-origin'});
          if (!response.ok) throw new Error('Unable to load products');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const items = [...page.querySelectorAll('#product-grid > .grid__item')];
          if (!items.length) throw new Error('No products returned');
          if (!this.isConnected || !grid.isConnected) return;
          const fragment = document.createDocumentFragment();
          for (const item of items) fragment.append(document.importNode(item, true));
          grid.append(fragment);
          this.dataset.shown = String(Number(this.dataset.shown) + items.length);
          const next = page.querySelector('[data-bba-load-more]');
          if (next) link.href = next.getAttribute('href');
          else { link.hidden = true; status.focus({preventScroll:true}); }
          status.textContent = this.dataset.progress.replace('__SHOWN__', this.dataset.shown).replace('__TOTAL__', this.dataset.total);
          document.dispatchEvent(new CustomEvent('bba:collection-products-loaded', {detail:{count:items.length,nextUrl:next?.getAttribute('href')||''}}));
        } catch (error) {
          if (error.name !== 'AbortError' && this.isConnected) status.textContent = this.dataset.error;
        } finally {
          this.loading = false;
          this.removeAttribute('aria-busy');
          link.removeAttribute('aria-disabled');
          link.textContent = this.dataset.label;
        }
      }
    });
  }
  const catalog = document.querySelector('[data-bba-catalog]');
  if (!catalog || catalog.dataset.enhanced === 'true') return;
  catalog.dataset.enhanced = 'true';
  const preserveContext = () => {
    const params = new URLSearchParams(location.search);
    for (const form of catalog.querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile')) {
      form.querySelectorAll('[data-bba-context]').forEach(input => input.remove());
      for (const key of new Set(params.keys())) {
        if (key.startsWith('filter.') || ['sort_by','page','section_id'].includes(key)) continue;
        if ([...form.elements].some(input => input.name === key)) continue;
        for (const value of params.getAll(key)) {
          const input = document.createElement('input');
          input.type = 'hidden'; input.name = key; input.value = value; input.dataset.bbaContext = '';
          form.append(input);
        }
      }
    }
  };
  preserveContext();
  catalog.addEventListener('input', preserveContext, true);
  catalog.addEventListener('click', (event) => {
    const close = event.target.closest('[data-bba-close-filters], [data-bba-show-results]');
    const backdrop = event.target.matches('form.mobile-facets');
    if (!close && !backdrop) return;
    const drawer = event.target.closest('menu-drawer');
    if (!drawer) return;
    event.preventDefault(); event.stopPropagation();
    const summary = drawer.querySelector('summary');
    drawer.closeMenuDrawer(event, summary);
    summary.setAttribute('aria-expanded', 'false');
  }, true);
})();
